import React from 'react';
import { CordexaLoader } from './CordexaLoader';

export type ButtonPendingProps = {
  pending: boolean;
  children: React.ReactNode;
  pendingText?: string;
  className?: string;
};

export function ButtonPending({
  pending,
  children,
  pendingText,
  className,
}: ButtonPendingProps) {
  return (
    <span
      className={className}
      aria-busy={pending || undefined}
      style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}
    >
      {pending ? (
        <>
          <CordexaLoader variant="dots" size="sm" srLabel={pendingText ?? 'Processing'} />
          {pendingText ?? children}
        </>
      ) : (
        children
      )}
    </span>
  );
}
